import React, { Fragment } from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import "./author-details.m.css";

export function AuthorDetails({ story, config }) {
  const authors = get(story, ["authors"], []);
  const mountAt = get(config, ["mountAt"], "");
  const authorCount = authors.length;
  return (
    <div styleName="author" className="author-div">
      {authorCount <= 3 ? (
        authors.map((author, index) => {
          const designation = get(author, ["metadata", "designation"], "");
          const { slug } = author;
          return (
            <Fragment key={author.id}>
              <Link href={`${mountAt}/author/` + slug}>{author.name}</Link>
              {authorCount < 3 && designation && <> ({designation}) </>}
              {authorCount < 3 && index < authorCount - 1 && <> and </>}
              {authorCount === 3 && index < authorCount - 2 && <>, </>}
              {authorCount === 3 && index === 1 && <> and </>}
            </Fragment>
          );
        })
      ) : (
        <span>Gulf News Report</span>
      )}
    </div>
  );
}

export function MultipleAuthorDetails({ story, config }) {
  const authors = get(story, ["authors"], []);
  const mountAt = get(config, ["mountAt"], "");
  const authorCount = authors.length;
  return (
    <div styleName="multi-author-div">
      {authorCount > 3 &&
        story.authors?.map((author, index) => {
          const designation = get(author, ["metadata", "designation"], "");
          const { slug } = author;
          return (
            <Fragment key={author.id}>
              <Link href={`${mountAt}/author/` + slug}>{author.name}</Link>
              {authorCount > 3 && designation && <> ({designation})</>}
              {authorCount > 3 && index < authorCount - 2 && <>, </>}
              {authorCount > 3 && index === authorCount - 2 && <> and </>}
            </Fragment>
          );
        })}
    </div>
  );
}
